// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"31074136","540":"a49b7434","568":"267522cb","706":"35924a96"}[chunkId] + ".chunk.css";
};